import React, { useRef, useState, useCallback, useMemo, useEffect } from "react";

import logger from "../../../../utils/LoggerFrontend";
import { SeekBar } from "../Components";
import { getTimeString } from "./utils";
import * as SC from "./MusicPlayer.styled.js";
import { EditIcon } from "../Svg/index.js";

const MusicPlayer = ({ postData, showAudioLibrary, setShowAudioLibrary }) => {
  const audioRef = useRef(null);
  const duration = audioRef?.current?.duration || 0;

  const [showAnimation, setShowAnimation] = useState(true);
  const [musicData, setMusicData] = useState(postData || {});
  const [isAudioPlaying, setIsAudioPlaying] = useState(false);
  const [currentTime, setCurrentTime] = useState(0);

  logger.debug("PostEditorSpotify:MusicPlayer", "Start render", { isAudioPlaying, postData });

  useEffect(() => {
    if (postData) {
      setMusicData(postData);
    }
  }, [postData]);

  const audioUrl = useMemo(() => {
    if (audioRef?.current) {
      audioRef.current.load();
    }

    return musicData?.url || "";
  }, [musicData?.url]);

  const pauseAudio = useCallback(() => {
    if (audioRef) {
      audioRef.current.pause();
      setIsAudioPlaying(false);
    }
  }, [audioRef]);

  const playAudio = useCallback(() => {
    logger.log("PostEditorSpotify:MusicPlayer:playAudio", "play audio", {
      isAudioPlaying,
      audioUrl
    });

    if (!audioUrl) {
      toggleAudioLibrary();
    }
    if (audioRef) {
      audioRef.current.play();
      setIsAudioPlaying(true);
    }
  }, [audioRef, isAudioPlaying, audioUrl]);

  const setSeekOnAudio = useCallback(
    (e) => {
      if (audioRef) {
        audioRef.current.currentTime = e.target.value;
      }
    },
    [audioRef]
  );

  const setSeekOnInput = useCallback(() => {
    if (audioRef) {
      setCurrentTime(audioRef.current.currentTime);
    }
  }, [audioRef]);

  const toggleAudioLibrary = useCallback(() => {
    setShowAudioLibrary(!showAudioLibrary);
    if (showAnimation) {
      setShowAnimation(false);
    }
  }, [showAudioLibrary, setShowAudioLibrary, showAnimation]);

  useEffect(() => {
    logger.log("PostEditorSpotify:MusicPlayer:resetCurrentTime", "called", {
      currentTime,
      duration
    });

    if (currentTime >= duration) {
      setCurrentTime(0);
      setIsAudioPlaying(false);
    }
  }, [currentTime, duration]);

  logger.debug("PostEditorSpotify:MusicPlayer", "render", {
    audioUrl,
    duration,
    musicData,
    currentTime
  });

  const togglePreviewEditor = () => {
    // Stop animation after clicking edit button
    if (showAnimation) {
      setShowAnimation(false);
    }

    toggleAudioLibrary();
  };

  return (
    <>
      {/* eslint-disable-next-line */}
      <audio controls style={{ display: "none" }} ref={audioRef} onTimeUpdate={setSeekOnInput}>
        <track />
        <source src={audioUrl} type="audio/mp3" />
      </audio>
      <SeekBar min={0} step={0.1} max={duration} value={currentTime} onChange={setSeekOnAudio} />
      <SC.BarTime>
        <SC.Times>{getTimeString(currentTime)}</SC.Times>
        <SC.Times>-{getTimeString(duration - currentTime)}</SC.Times>
      </SC.BarTime>
      <SC.MusicButtons>
        <SC.Prev />
        {isAudioPlaying ? <SC.Pause onClick={pauseAudio} /> : <SC.Play onClick={playAudio} />}
        <SC.Next />
        <SC.Edit showAnimation={showAnimation} onClick={togglePreviewEditor}>
          <EditIcon />
        </SC.Edit>
      </SC.MusicButtons>
    </>
  );
};
export default MusicPlayer;
